export interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  summary: string;
  content: string;
  image: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isTrending: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '娱乐爆料', slug: 'entertainment' },
  { name: '明星八卦', slug: 'celebrity' },
  { name: '社会热点', slug: 'social' },
  { name: '影视综艺', slug: 'tv-show' },
  { name: '时尚潮流', slug: 'fashion' },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '顶流男星深夜密会神秘女子，酒店共度8小时引热议',
    slug: 'top-star-secret-date-8-hours',
    category: '明星八卦',
    categorySlug: 'celebrity',
    summary: '近日有媒体拍到某顶流男星深夜与一位神秘女子共同进入某五星级酒店，直到次日清晨才分别离开，引发网友疯狂猜测女方身份。',
    content: `<p>近日，有资深娱记拍到某当红顶流男星深夜与一位神秘女子共同进入北京某五星级酒店的画面。据目击者称，两人全程保持低调，戴着口罩和帽子，但能看出举止亲密。</p>
    <p>据悉，该男星当晚约11点左右驾车抵达酒店地下车库，随后一位身材高挑的女子从副驾驶下车，两人一前一后进入酒店电梯。直到次日早上7点左右，该男星才独自驾车离开，而女子则在半小时后被一辆保姆车接走。</p>
    <p>消息曝光后，网友纷纷开启"侦探模式"，从女子的身高体型、穿搭风格等方面进行推测。有人猜测是某95后小花，也有人认为是圈外素人女友。截至目前，该男星工作室尚未对此事作出回应。</p>
    <p>值得一提的是，该男星此前曾在采访中表示自己目前单身，专注事业。此次事件让不少粉丝感到震惊，社交媒体上相关话题迅速登上热搜榜首。</p>
    <p>业内人士分析称，近年来顶流艺人私生活的曝光往往伴随着巨大的舆论压力，建议公众理性吃瓜，给艺人留出适当的私人空间。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20in%20dark%20suit%20walking%20at%20night%20near%20luxury%20hotel%2C%20paparazzi%20style%20photography%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20mood%2C%20warm%20street%20lights%2C%20blurred%20background%20with%20city%20night%20lights&width=800&height=450&seq=article-1&orientation=landscape',
    author: '朝阳群众',
    date: '2026-08-04',
    views: 128500,
    tags: ['顶流男星', '恋情曝光', '酒店密会', '吃瓜'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 2,
    title: '某综艺录制现场突发意外，导演组紧急叫停引发争议',
    slug: 'variety-show-accident-controversy',
    category: '影视综艺',
    categorySlug: 'tv-show',
    summary: '热播综艺节目录制过程中突发设备故障，导致一位嘉宾轻微受伤，节目组处理方式引发观众不满，社交平台上争议不断。',
    content: `<p>昨日，一档备受关注的真人秀综艺节目在录制过程中突发意外。据现场观众透露，录制进行到游戏环节时，舞台上的机械装置突然发生故障，导致正在参与挑战的一位嘉宾从约两米高的平台上滑落。</p>
    <p>幸运的是，该嘉宾仅受了轻微擦伤，经过现场医护人员处理后已无大碍。但令人不满的是，节目组在事发后仅暂停录制不到半小时，便要求继续完成剩余环节的拍摄。</p>
    <p>此事被现场观众曝光后迅速在社交平台发酵，不少网友对节目组的安全措施提出质疑。"安全第一不是口号，出了事还继续录，太不负责任了！"一位网友评论道。</p>
    <p>节目组随后发布声明，称已对相关设备进行了全面检查，并对受伤嘉宾表达了歉意。声明中强调"始终将艺人安全放在首位"，但并未提及为何在事故后迅速恢复录制。</p>
    <p>业内人士指出，综艺节目录制强度大、节奏快是行业常态，但安全问题绝不能妥协。此次事件也引发了对综艺行业安全标准的大讨论。</p>`,
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20studio%20with%20colorful%20stage%20lights%2C%20crew%20members%20working%2C%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20production%2C%20professional%20lighting%20equipment%2C%20warm%20spotlights&width=800&height=450&seq=article-2&orientation=landscape',
    author: '娱乐圈观察员',
    date: '2026-08-03',
    views: 96500,
    tags: ['综艺事故', '节目录制', '安全争议', '真人秀'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 3,
    title: '知名导演新作票房口碑双扑街，深夜发文回应质疑',
    slug: 'director-box-office-failure-response',
    category: '娱乐爆料',
    categorySlug: 'entertainment',
    summary: '曾执导多部爆款电影的知名导演最新力作上映首周票房惨淡，豆瓣评分跌破5分，该导演深夜发文回应网络差评。',
    content: `<p>曾凭借多部现象级电影斩获百亿票房的知名导演张某，其最新力作上映首周票房仅突破8000万，远低于业界预期的3亿目标。更令人意外的是，该片在豆瓣上的评分已跌至4.8分，创下该导演职业生涯最低分。</p>
    <p>面对铺天盖地的差评，该导演于凌晨2点在个人社交账号发布长文回应。文中称"每一部作品都是用心之作，观众的反馈我全部收到了"，但也暗示部分差评存在"恶意刷分"的可能。</p>
    <p>这篇回应发布后，舆论进一步分化。支持者认为导演敢于直面批评值得尊重，反对者则认为这是在"甩锅"观众审美。</p>
    <p>影评人分析认为，该片票房失利的主要原因在于剧本薄弱和叙事节奏混乱，而这些问题在预告片阶段就已初现端倪。加之同期有多部好莱坞大片上映，其生存空间被进一步挤压。</p>
    <p>据悉，该导演目前已着手筹备下一部作品，希望能借此翻身。业内普遍认为，这次失利或将成为其创作生涯的重要转折点。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20film%20director%20sitting%20alone%20in%20empty%20cinema%20theater%2C%20dim%20lighting%2C%20contemplative%20mood%2C%20cinematic%20atmosphere%2C%20red%20velvet%20seats%2C%20movie%20screen%20with%20faint%20light&width=800&height=450&seq=article-3&orientation=landscape',
    author: '影视圈内人',
    date: '2026-08-03',
    views: 87500,
    tags: ['导演', '票房扑街', '豆瓣评分', '电影'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 4,
    title: '当红小花被曝片场耍大牌，多名工作人员匿名爆料细节',
    slug: 'actress-diva-behavior-exposed',
    category: '娱乐爆料',
    categorySlug: 'entertainment',
    summary: '一位95后当红女演员被多名剧组工作人员匿名爆料在片场存在耍大牌行为，包括迟到早退、不配合拍摄等，引发网友热议。',
    content: `<p>近日，一位95后当红小花旦被多名剧组工作人员匿名爆料，直指其在片场存在严重的耍大牌行为。爆料内容涉及迟到早退、拒绝配合拍摄、对工作人员态度恶劣等多个方面。</p>
    <p>据一位不愿透露姓名的场务人员透露，该女演员曾因"心情不好"为由临时取消当天的所有拍摄计划，导致整个剧组损失数十万元。另一位化妆师则表示，该演员经常对妆容挑三拣四，每次改妆都要耗费两三个小时。</p>
    <p>消息传出后，该女演员的粉丝迅速组织"控评"，声称这是对家团队的恶意抹黑。但也有不少网友表示，类似传闻并非首次出现，"无风不起浪"。</p>
    <p>截至目前，该演员的工作室尚未对此事作出正式回应。但有媒体注意到，其工作室在爆料发布后的两小时内连续更新了多条日常动态，被解读为"冷处理"策略。</p>
    <p>圈内资深经纪人表示，年轻艺人走红后心态失衡并不罕见，关键在于能否及时调整。"观众缘是最珍贵的资产，一旦失去就很难挽回。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20actress%20on%20film%20set%20wearing%20elegant%20dress%2C%20surrounded%20by%20film%20crew%20and%20equipment%2C%20studio%20lighting%2C%20professional%20cinematography%20setup%2C%20dramatic%20mood&width=800&height=450&seq=article-4&orientation=landscape',
    author: '剧组知情人',
    date: '2026-08-02',
    views: 112300,
    tags: ['95后小花', '耍大牌', '片场爆料', '娱乐圈'],
    isHot: true,
    isTrending: false,
  },
  {
    id: 5,
    title: '某知名品牌代言人突然解约，背后原因引发多种猜测',
    slug: 'brand-ambassador-sudden-termination',
    category: '时尚潮流',
    categorySlug: 'fashion',
    summary: '国际知名奢侈品牌突然宣布与代言人解除合约，官方声明含糊其辞，各种猜测在网络上迅速蔓延。',
    content: `<p>今日上午，某国际一线奢侈品牌在官方社交平台发布简短声明，宣布与中国区品牌代言人、知名演员李某正式解约。声明中仅表示"双方经友好协商后决定终止合作关系"，未提及具体原因。</p>
    <p>这一突如其来的消息迅速在网络上引发轩然大波。该演员与该品牌的合作始于三年前，期间一直保持良好的合作关系，去年还曾为该品牌拍摄了全球广告大片。</p>
    <p>关于解约原因，网络上出现了多种版本的猜测。有说法称该演员近期卷入的负面新闻影响了品牌形象，也有业内人士透露是品牌方调整亚太区战略导致的人事变动，还有传言称是该演员主动提出解约以寻求更高端的合作。</p>
    <p>值得注意的是，在该品牌发布解约声明后不到三小时，另一个竞争品牌在社交平台上关注了该演员的账号，被网友解读为"暗示新合作即将官宣"。</p>
    <p>时尚评论人认为，品牌代言人的更替在时尚行业属于正常现象，但如此突然的解约确实罕见，其背后可能涉及更为复杂的商业博弈。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20fashion%20advertisement%20photoshoot%20scene%2C%20elegant%20Chinese%20model%20in%20designer%20clothing%2C%20high%20fashion%20studio%20with%20soft%20diffused%20lighting%2C%20minimalist%20luxury%20aesthetic&width=800&height=450&seq=article-5&orientation=landscape',
    author: '时尚圈日报',
    date: '2026-08-02',
    views: 76500,
    tags: ['品牌代言', '解约风波', '奢侈品牌', '时尚圈'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 6,
    title: '某热门IP改编剧选角争议不断，原著粉集体抵制引关注',
    slug: 'ip-adaptation-casting-controversy',
    category: '影视综艺',
    categorySlug: 'tv-show',
    summary: '备受期待的超级IP改编剧公布主演阵容后引发原著粉丝强烈不满，"毁原著"话题登上热搜，制片方紧急回应。',
    content: `<p>改编自网络小说大神级作品的电视剧《XXXX》昨日正式公布主演阵容，却意外引发了原著粉丝的集体抵制。社交媒体上"XXXX选角失败"的话题在短短两小时内阅读量突破3亿。</p>
    <p>原著粉丝的主要不满集中在两个方面：一是主演的年龄和形象与原著角色设定存在较大差距；二是部分重要配角的选角被认为"带资进组"，演技存疑。有粉丝制作了详细的对比图，指出选角与原著描述的多处不符。</p>
    <p>面对汹涌的舆论，制片方于今日上午发布紧急声明，称选角过程"经过多轮严格筛选"，并呼吁观众"给作品一个机会"。但这一回应并未平息粉丝的怒火，反而引发了新一轮的讨论。</p>
    <p>近年来，IP改编剧频频因选角问题引发争议，从《XXXX》到《XXXX》，几乎每一部大IP影视化都逃不过原著粉的"审判"。有评论指出，这反映了创作者在商业考量和艺术尊重之间的失衡。</p>
    <p>该剧目前尚未开拍，知情人士透露制片方内部正在讨论是否调整部分角色的人选。这场选角风波将如何收场，值得持续关注。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20audition%20scene%2C%20actors%20in%20traditional%20hanfu%20clothing%2C%20casting%20call%20atmosphere%2C%20film%20studio%20with%20ancient%20Chinese%20architecture%20set%2C%20dramatic%20lighting&width=800&height=450&seq=article-6&orientation=landscape',
    author: '剧集观察家',
    date: '2026-08-01',
    views: 145200,
    tags: ['IP改编', '选角争议', '原著粉', '电视剧'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 7,
    title: '娱乐圈模范夫妻被传婚变，双方同时沉默引发猜测',
    slug: 'model-couple-divorce-rumors',
    category: '明星八卦',
    categorySlug: 'celebrity',
    summary: '被誉为娱乐圈模范夫妻的某对明星夫妇被网友发现已数月未同框互动，双方社交账号同时停更，婚变传闻甚嚣尘上。',
    content: `<p>曾被粉丝称为"娱乐圈最后的神仙爱情"的某对明星夫妇，近期被网友发现了一系列可疑迹象：两人已连续四个月未在社交平台上互动，最近一次同框还是在半年前的一场商业活动上。</p>
    <p>更引人注目的是，双方的社交账号在最近两周内同时停止了更新。女方的最新动态停留在两周前的一条广告内容，而男方的账号则在一个月前发布了最后一条工作相关的内容后便再无更新。</p>
    <p>有自称知情人士的网友在匿名平台爆料，称两人实际上已经在三个月前秘密签署了离婚协议，之所以不公开是因为涉及巨额的商业代言合同。但这一说法目前无法得到证实。</p>
    <p>该夫妇的共同好友、某知名主持人被媒体追问此事时，仅以"不太清楚"作为回应，并未正面否认，这进一步加剧了外界的猜测。</p>
    <p>媒体尝试联系双方经纪人，但均未获得回复。在娱乐圈，沉默往往被解读为默认，这对曾经的模范夫妻究竟发生了什么，恐怕只有时间能给出答案。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20looking%20apart%20in%20elegant%20setting%2C%20emotional%20distance%2C%20soft%20dramatic%20lighting%2C%20high%20end%20photography%2C%20moody%20atmosphere%2C%20luxury%20interior&width=800&height=450&seq=article-7&orientation=landscape',
    author: '八卦早知道',
    date: '2026-08-01',
    views: 167800,
    tags: ['模范夫妻', '婚变传闻', '明星婚姻', '八卦'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 8,
    title: '某短视频平台网红涉嫌虚假宣传被立案调查',
    slug: 'influencer-false-advertising-investigation',
    category: '社会热点',
    categorySlug: 'social',
    summary: '拥有千万粉丝的短视频平台头部网红因涉嫌在其直播带货中虚假宣传产品功效，已被市场监管部门正式立案调查。',
    content: `<p>近日，某短视频平台拥有超过2000万粉丝的头部网红"XXX"因涉嫌在直播带货中虚假宣传，被其所在地的市场监督管理部门正式立案调查。这也是今年以来第三起因虚假宣传被调查的头部网红案件。</p>
    <p>据调查，该网红在多次直播中宣称其销售的某款护肤品具有"三天美白""一周祛斑"等功效，并声称自己使用了该产品后才拥有了"完美的皮肤状态"。然而，多名消费者购买使用后不仅未见效果，还出现了不同程度的皮肤过敏反应。</p>
    <p>市场监管部门在接到大量消费者投诉后展开调查，初步认定该网红的行为涉嫌违反《广告法》和《反不正当竞争法》的相关规定。如果最终认定成立，该网红可能面临高额罚款，甚至被平台永久封禁账号。</p>
    <p>此事在网络上引发了关于直播带货监管的广泛讨论。有专家呼吁平台应承担更多的审核责任，从源头上遏制虚假宣传。也有消费者表示，网红带货"翻车"事件频发，自己已经不再信任任何网红推荐的产品。</p>
    <p>据业内人士透露，多个直播平台已经开始收紧对带货内容的事前审核标准，网红带货行业的合规化进程或将因此加速。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20influencer%20studio%20with%20ring%20light%20and%20products%20on%20desk%2C%20modern%20streaming%20setup%2C%20smartphone%20on%20tripod%2C%20warm%20studio%20lighting%2C%20social%20media%20content%20creation&width=800&height=450&seq=article-8&orientation=landscape',
    author: '热点聚焦',
    date: '2026-07-31',
    views: 203400,
    tags: ['网红', '直播带货', '虚假宣传', '立案调查'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 9,
    title: '某音乐选秀节目冠军被曝学历造假，人设崩塌引发连锁反应',
    slug: 'talent-show-winner-degree-fraud',
    category: '娱乐爆料',
    categorySlug: 'entertainment',
    summary: '去年爆火的音乐选秀节目总冠军被网友扒出其声称的海外名校学历疑似造假，多个代言品牌已宣布暂停合作。',
    content: `<p>去年在某大型音乐选秀节目中一举夺魁的歌手王某，近日被网友扒出其自称的"伯克利音乐学院毕业"学历疑似造假。据调查，王某仅在伯克利参加过为期两周的暑期交流项目，而非其简历中暗示的全日制本科教育。</p>
    <p>此事由一个专注"学术打假"的网友账号率先曝光。该网友通过查询伯克利音乐学院的校友数据库和学生注册系统，发现王某的名字并未出现在任何学位授予名单中。随后，更多关于王某背景造假的线索被网友陆续挖出。</p>
    <p>学历造假事件曝光后，已有三家品牌方宣布暂停与王某的合作关系。一位品牌营销负责人向媒体表示："我们签约时看中的正是他'学霸歌手'的人设，现在人设崩塌，继续合作的风险太大了。"</p>
    <p>王某的经纪公司于昨晚发布致歉声明，承认其在个人简介中"存在夸大表述"，但强调王某的音乐才华"毋庸置疑"。不过，这一回应被网友批评为避重就轻、缺乏诚意。</p>
    <p>圈内人士分析认为，此次事件将对王某的职业生涯产生长期影响。"在娱乐圈，人设一旦崩塌，重建信任的难度远超想象。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20young%20singer%20on%20music%20talent%20show%20stage%2C%20spotlight%20performance%2C%20dramatic%20stage%20lighting%2C%20emotional%20singing%20moment%2C%20grand%20stage%20production%2C%20music%20competition%20atmosphere&width=800&height=450&seq=article-9&orientation=landscape',
    author: '打假先锋',
    date: '2026-07-31',
    views: 189600,
    tags: ['学历造假', '人设崩塌', '选秀冠军', '品牌解约'],
    isHot: true,
    isTrending: false,
  },
  {
    id: 10,
    title: '某国际电影节中国影片颗粒无收，评委内幕遭曝光',
    slug: 'chinese-film-festival-no-awards-controversy',
    category: '影视综艺',
    categorySlug: 'tv-show',
    summary: '在刚刚落幕的某国际A类电影节上，入围的三部中国影片无一获奖，一位评委匿名爆料评审过程中的不公平现象。',
    content: `<p>第XX届国际电影节昨日落下帷幕，令中国电影界感到失望的是，入围主竞赛单元的三部中国影片无一斩获奖项。更令人震惊的是，一位不愿透露姓名的评委赛后匿名向媒体爆料，称评审过程中存在明显的"地域偏见"。</p>
    <p>据该评委透露，在评审讨论环节，多位欧洲评委对中国影片的评价带有明显的"先入为主的偏见"，甚至在未完整观看影片的情况下就给出了较低分数。该评委还称，有评审在讨论中使用了"东方叙事方式难以理解"等带有文化歧视意味的表述。</p>
    <p>消息传出后，中国电影界反应强烈。多位知名导演和影评人在社交平台上发声，认为国际电影节应该真正尊重多元文化，而非以西方审美为唯一标准。</p>
    <p>但也有理性的声音指出，中国电影在国际舞台上的表现确实有提升空间。"抱怨评委不公不如反思自己的创作水准，"一位资深影评人评论道，"我们首先需要拍出具有普世价值的好电影。"</p>
    <p>该电影节组委会尚未对此事件作出正式回应。中国电影与国际舞台的关系，将是一个长期需要面对的话题。</p>`,
    image: 'https://readdy.ai/api/search-image?query=International%20film%20festival%20award%20ceremony%20stage%2C%20red%20carpet%20empty%20and%20golden%20statue%20trophy%2C%20cinema%20spotlight%2C%20glamorous%20evening%20event%20atmosphere%2C%20theater%20audience%20and%20stage&width=800&height=450&seq=article-10&orientation=landscape',
    author: '电影节前线',
    date: '2026-07-30',
    views: 94500,
    tags: ['国际电影节', '中国电影', '评审争议', '奖项'],
    isHot: false,
    isTrending: false,
  },
  {
    id: 11,
    title: '某女星深夜发文暗讽同行，娱乐圈塑料姐妹花再添实锤',
    slug: 'actress-cryptic-post-feud',
    category: '明星八卦',
    categorySlug: 'celebrity',
    summary: '一位90后女演员深夜在社交平台发布了一段意味深长的文字，被网友解读为暗讽另一位同期女星，两人的"塑料姐妹情"再次成为话题。',
    content: `<p>昨晚凌晨1点，90后女演员赵某在其个人社交账号发布了一段文字："有些人表面上跟你称姐道妹，背地里却做着见不得光的事。时间会证明一切。"虽然未指名道姓，但发布时间恰好是在另一位女演员孙某新剧开播发布会结束后两小时。</p>
    <p>赵某与孙某曾是圈内公认的"好闺蜜"，两人经常在社交媒体上互动，还一起参加过综艺节目。但自从去年两人同台竞争同一部大制作电影的女主角后，关系似乎出现了微妙变化。细心的网友发现，两人已经有一年多没有公开互动了。</p>
    <p>赵某的这段文字发布后，孙某的粉丝迅速涌入评论区进行反击，认为这是"蹭热度"的行为。而赵某的粉丝则力挺偶像，称这是"真性情的表达"。两个粉丝群体在网络上展开了激烈的口水战。</p>
    <p>有圈内人士私下透露，两人之间的矛盾远比外界想象的复杂，涉及资源竞争、团队利益等多个层面。"娱乐圈的友情，在利益面前往往不堪一击。"</p>
    <p>截至发稿时，孙某方面尚未对赵某的言论作出回应。但可以肯定的是，这对曾经的"好闺蜜"已经很难回到当初的关系了。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Two%20young%20Chinese%20actresses%20standing%20back%20to%20back%20in%20elegant%20gowns%2C%20dramatic%20split%20lighting%2C%20tension%20atmosphere%2C%20studio%20portrait%2C%20fashion%20editorial%20style%2C%20cold%20color%20contrast&width=800&height=450&seq=article-11&orientation=landscape',
    author: '八卦圈内人',
    date: '2026-07-30',
    views: 135600,
    tags: ['女星暗讽', '塑料姐妹', '闺蜜反目', '娱乐圈'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 12,
    title: '某热门网剧因内容违规被下架整改，网友态度两极分化',
    slug: 'web-drama-removed-censorship',
    category: '社会热点',
    categorySlug: 'social',
    summary: '一部正在热播的网络剧突然从各大平台下架，官方称存在内容违规问题需要整改，观众对此事的看法呈现明显的两极分化。',
    content: `<p>正在多个视频平台同步热播的网络剧《XXXX》于昨日晚间突然全平台下架，播放页面仅显示"应主管部门要求，该内容暂时下架整改"。消息传出后，迅速登上社交平台热搜榜。</p>
    <p>据业内人士透露，该剧被下架的主要原因涉及三个方面：部分情节涉及敏感社会议题、剧中角色价值观存在争议、以及部分场景被认为过度渲染暴力。主管部门已向制作方发出整改通知，要求对相关内容进行调整后才能重新上架。</p>
    <p>观众对此事的反应呈现两极分化。支持整改的观众认为，影视作品应该承担社会责任，不应为了追求流量而挑战底线。"有些内容确实不适合在公开平台传播，整改是必要的。"</p>
    <p>而反对整改的观众则认为，该剧恰恰因为敢于触碰现实议题才获得了观众的共鸣。"一刀切的下架处理只会扼杀创作自由，"有观众在评论区写道。</p>
    <p>近年来，网络视听内容的审核尺度一直是业界关注的话题。如何在保障创作自由与维护社会价值之间找到平衡点，仍是一个需要持续探索的课题。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20web%20drama%20streaming%20on%20laptop%20screen%20with%20removed%20error%20message%2C%20modern%20home%20viewing%20setup%2C%20dim%20room%20lighting%2C%20digital%20streaming%20platform%20interface&width=800&height=450&seq=article-12&orientation=landscape',
    author: '社会观察者',
    date: '2026-07-29',
    views: 178300,
    tags: ['网剧下架', '内容审核', '整改', '社会议题'],
    isHot: false,
    isTrending: true,
  },
];

export const hotTags = ['顶流男星', '综艺事故', '学历造假', '婚变传闻', '直播带货', 'IP改编', '选角争议', '品牌解约'];

export const aboutInfo = {
  brandName: '51cg吃瓜网',
  foundedYear: '2020',
  description: '51cg吃瓜网是国内领先的娱乐资讯聚合平台，致力于为广大"吃瓜群众"提供最新、最快、最全面的娱乐八卦和热点资讯。我们秉持真实、客观、有趣的内容理念，让每一位用户都能在这里享受到轻松愉快的"吃瓜"体验。',
  mission: '做最懂吃瓜群众的娱乐资讯平台，让八卦变得更有趣、更有料、更有温度。',
  stats: [
    { label: '日活用户', value: '500万+' },
    { label: '日更新文章', value: '200+篇' },
    { label: '合作媒体', value: '100+家' },
    { label: '累计阅读', value: '50亿+' },
  ],
  reputation: [
    { platform: 'App Store', rating: '4.8', comment: '吃瓜必备App，每天必刷！' },
    { platform: '华为应用市场', rating: '4.7', comment: '资讯更新快，内容很有趣' },
    { platform: '小米应用商店', rating: '4.6', comment: '界面清爽，体验很好' },
    { platform: '用户口碑', rating: '4.9', comment: '全网最全的吃瓜平台' },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座1508室',
    phone: '400-888-5151',
    email: 'contact@51cg.fun',
    wechat: '51cg_official',
    weibo: '@51cg吃瓜网',
  },
};